module.exports = __webpack_public_path__ + "img/team.f5424126.svg";